// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"426fd471","5414":"00bcb22d","8950":"defd12b5"}[chunkId] + ".chunk.css";
};